import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Clipboard } from '@capacitor/clipboard';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { LibraryService } from '../../../core/services/library/library.service';
import { ToastService } from '../../../core/services/toast/toast.service';
import { OtpQuery } from '../../state/otp/otp.query';

@Component({
    standalone: false,
    selector: 'app-otp-form',
    templateUrl: './otp-form.component.html',
    styleUrls: ['./otp-form.component.scss'],
})
export class OtpFormComponent implements OnInit {
    otpForm: FormGroup;
    labelOtpInfo = '';

    constructor(
        private formBuilder: FormBuilder,
        private libraryService: LibraryService,
        private toastService: ToastService,
        private otpQuery: OtpQuery
    ) {}

    ngOnInit(): void {
        this.initForm();

        combineLatest([
            this.otpQuery.select((state) => state.email),
            this.libraryService.getLabelStream('lbl_mail_otp_info'),
        ])
            .pipe(
                map(([email, label]) =>
                    label.replace(
                        '###EMAIL###',
                        `<span class="email">${email}</span>`
                    )
                )
            )
            .subscribe((label) => {
                this.labelOtpInfo = label;
            });
    }

    private initForm() {
        this.otpForm = this.formBuilder.group({
            otp: [
                '',
                [
                    Validators.maxLength(6),
                    Validators.minLength(6),
                    Validators.required,
                    Validators.pattern(/^([0-9]\d*)?$/),
                ],
            ],
        });
    }

    get controls() {
        return this.otpForm.controls;
    }

    async pasteCode() {
        try {
            const { value } = await Clipboard.read();
            const code = value?.trim().slice(0, 6);

            if (!code) {
                throw new Error();
            }

            this.controls.otp.setValue(code);
            this.controls.otp.markAsTouched();
        } catch (e) {
            this.toastService.presentInfoToast(
                this.libraryService.getLabel('lbl_not_found_clipboard')
            );
        }
    }
}
